import { DetailCardSection, DetailList, DetailRow, formatDateTime, IdValue, Table } from "@prequel/shared-components";

import { schemaColumns } from "@/components/import/schemaColumns";
import { useDestinationContext } from "@/pages/import/DestinationsPage/DestinationPage";
import { TYPE_LABELS } from "@/pages/import/DestinationsPage/DestinationsTable";
import { getDestinationFields } from "@/pages/import/recordSchema";

const SCHEMA_COLUMNS = schemaColumns(["Field", "Type", "Required"]);

const DestinationOverview = () => {
  const { destination } = useDestinationContext();

  const webhook = destination.webhook_batch ?? destination.webhook_record;
  const schemaRows = getDestinationFields(destination.record_schema).map((field) => ({
    id: field.name,
    cells: [
      { value: <span className="font-mono text-stone-800">{field.name}</span> },
      {
        value: (
          <span className="rounded-sm bg-stone-100 px-2 py-0.5 font-mono text-xs text-stone-700">{field.type}</span>
        ),
      },
      { value: field.required ? "Required" : "Optional" },
    ],
  }));

  return (
    <div className="mt-6">
      <DetailCardSection title="Details">
        <DetailList>
          <DetailRow label="ID" value={<IdValue id={destination.id} />} />
          <DetailRow label="Name" value={destination.name} />
          <DetailRow label="Type" value={TYPE_LABELS[destination.type] ?? destination.type} />
          {webhook && <DetailRow label="Endpoint URL" value={<IdValue id={webhook.request_template.uri} />} />}
          <DetailRow label="Created at" value={formatDateTime(destination.created_at)} />
          {webhook && <DetailRow label="Method" value={webhook.request_template.method} />}
          {destination.webhook_batch && (
            <>
              <DetailRow label="Format" value={destination.webhook_batch.format} />
              <DetailRow label="Max records per batch" value={destination.webhook_batch.max_size_per_batch} />
              <DetailRow label="Max batches per minute" value={destination.webhook_batch.max_batches_per_minute} />
            </>
          )}
          {destination.webhook_record && (
            <DetailRow label="Max records per minute" value={destination.webhook_record.max_records_per_minute} />
          )}
          {webhook && <DetailRow label="Max concurrency" value={webhook.max_concurrency} />}
          <DetailRow label="Updated at" value={formatDateTime(destination.updated_at)} />
        </DetailList>
      </DetailCardSection>

      <section className="mb-4">
        <Table
          header={<h3 className="mb-2 text-sm font-medium text-stone-800">Target schema</h3>}
          columns={SCHEMA_COLUMNS}
          rows={schemaRows}
          emptyState="No target schema configured."
        />
      </section>
    </div>
  );
};

export default DestinationOverview;
